import request from '@/utils/request';

export function getScholarshipPlanInfo() {
  return request({
    url: '/Marketing/autumnScholarship2019',
  });
}

export function receiveCoupon(id, activityType) {
  return request({
    url: '/CouponCollect/join',
    method: 'POST',
    data: {
      id,
      activityType,
    },
  });
}
